import { FORM_TYPE } from "./custom-define-type";
export const LIST_BOOKING_ADDRESS_FIELDS = [{
    type: FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.BOOKING_ADDRESS",
    model: "address1",
},
{
    type: FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.ADDRESS_LINE2",
    model: "address2",
    isRequired: false,
},
{
    type: FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.CITY",
    itemPerRow: 3,
    model: "city",
},
{
    type: FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.STATE",
    itemPerRow: 3,
    model: "provincestate",
},
{
    type: FORM_TYPE.TEXTBOX,
    keyLangLabel: "BOOKING_DIALOG.LABEL.ZIP_CODE",
    itemPerRow: 3,
    model: "postal_code",
}
]


// WEBPACK FOOTER //
// ./src/constants/list-fields.js